import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import RadioGroup, { RadioGroupProps } from "@material-ui/core/RadioGroup";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import VerbFrequencyIcon from "../cards/VerbFrequencyIcon";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import { getFirestore } from "redux-firestore";
import "./AddGender.scss";
import GenderScrapper from "./GenderScrapper";

const AddGender = (props) => {
  const [formType, setFormType] = useState("New");
  const [headline, setHeadline] = useState("Add new word");
  const [Word, setWord] = useState("");
  const [Article, setArticle] = useState("M");
  const [Example, setExample] = useState("");
  const [Plural, setPlural] = useState("");
  const [Level, setLevel] = useState(0);
  const [Frequency, setFrequency] = useState("");
  const [Rule, setRule] = useState("");
  const [Skip, setSkip] = useState(false);
  const [id, setID] = useState(0);
  const [ReadExample, setReadExample] = useState(false);
  const [Bookmark, setBookmark] = useState(false);
  const UpdateField = (field_name, type) => {
    // var selected_items = [];
    // selected_items[0] = this.state.verbs[this.state.currentWordId].id;
    // this.props.fieldUpdate(selected_items, type, "verbs", field_name);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    save();
    // createGenderWord()
  };

  const createWord = () => {
    return {
      Word: Word,
      Article: Article,
      Example: Example,
      Plural: Plural,
      Frequency: Frequency,
      Skip: Skip,
      ReadExample: ReadExample,
      Bookmark: Bookmark,
      Level: Level,
      Rule: Rule,
      createdAt: new Date(),
    };
  };

  const createGenderWord = () => {
    const firestore = getFirestore();
    firestore
      .collection("gender")
      .add(createWord())
      .then(() => {
        console.log("sucess");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateGenderWord = () => {
    const firestore = getFirestore();
    firestore
      .collection("gender")
      .doc(id)
      .update(createWord())
      .then(() => {
        console.log("sucess");
      })
      .catch((err) => {
        console.log(err);
      });
    props.handleClose(true, createWord());
  };

  const ScrapperCall = (prular) => {
    setPlural(prular);
  };

  useEffect(() => {
    console.log(props.word);
    if (props.word != null) {
      setWord(props.word.Word);
      setArticle(props.word.Article);
      setExample(props.word.Example);
      setPlural(props.word.Plural);
      setLevel(props.word.Level);
      setFrequency(props.word.Frequency);
      setRule(props.word.Rule);
      setSkip(props.word.Skip);
      setReadExample(props.word.ReadExample);
      setBookmark(props.word.Bookmark);
      setHeadline("Edit comic");
      setFormType("Edit");
      setID(props.word.id);
    }
  }, []);

  const validate = () => {
    return true;
  };
  const save = () => {
    if (validate()) {
      if (formType == "New") {
        createGenderWord();
      } else {
        updateGenderWord();
      }
    }
  };

  return (
    <Container maxWidth="xl">
      <Paper className="paper-container">
        <form
          onSubmit={handleSubmit}
          className="container white add-gender-form"
        >
          <Typography variant="h6" className="grey-text text-darken-3">
            {headline}
          </Typography>
          <TextField
            label="Word"
            value={Word}
            onChange={(e) => setWord(e.target.value)}
          />
          <GenderScrapper
            ScrapperCall={ScrapperCall}
            SearchedWord={Word}
          ></GenderScrapper>
          <FormControl className="filter__sort highlight1" component="fieldset">
            <FormLabel component="legend">Sort by:</FormLabel>
            <RadioGroup
              name="gender1"
              value={Article}
              onChange={(event) => setArticle(event.target.value)}
            >
              <FormControlLabel
                className="filter__item-text"
                value="M"
                control={<Radio />}
                label="M"
              />
              <FormControlLabel
                className="filter__item-text"
                value="F"
                control={<Radio />}
                label="F"
              />
              <FormControlLabel
                className="filter__item-text"
                value="N"
                control={<Radio />}
                label="N"
              />
            </RadioGroup>
          </FormControl>

          <TextField
            label="Example"
            multiline
            rowsMax={10}
            value={Example}
            onChange={(e) => setExample(e.target.value)}
          />
          <TextField
            label="Plural"
            value={Plural}
            onChange={(e) => setPlural(e.target.value)}
          />
          {/* <VerbFrequencyIcon
            UpdateField={UpdateField}
            frequency="A1"
          ></VerbFrequencyIcon> */}
          <TextField
            label="Frequency"
            value={Frequency}
            onChange={(e) => setFrequency(e.target.value)}
          />
          <TextField
            label="Level"
            type="number"
            value={Level}
            onChange={(e) => setLevel(e.target.value)}
          />
          <TextField
            label="Skip"
            type="number"
            value={Skip}
            onChange={(e) => setSkip(e.target.value)}
          />
          <TextField
            label="Rule"
            type="number"
            value={Skip}
            onChange={(e) => setSkip(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={ReadExample}
                onChange={(event) => setReadExample(event.target.checked)}
                name="ReadExample"
              />
            }
            label="Read Example"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={Bookmark}
                onChange={(event) => setBookmark(event.target.checked)}
                name="Bookmark"
              />
            }
            label="Bookmark"
          />
          <Button
            type="submit"
            value="Submit"
            variant="contained"
            //  color="secondary"
          >
            Save
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default AddGender;
